import $axios from '@/axios-instance.js'

export const productService = {
  getListData,
  getAll,
  getById,
  create,
  update,
  delete: _delete
}

function getListData (filter, page) {
  return $axios.get(`${process.env.ROOT_API}/products`, { params: Object.assign({ currentPage: page }, filter) }).then(response => {
    return response.data
  })
}

function getAll () {
  return $axios.get(`${process.env.ROOT_API}/products/get-all`).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/products/${id}`).then(response => {
    return response.data
  })
}

function create (product) {
  return $axios.post(`${process.env.ROOT_API}/products`, product).then(response => {
    return response.data
  })
}

function update (product) {
  return $axios.put(`${process.env.ROOT_API}/products/${product.productId}`, product).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/products/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/product.service.js